// Meter Type Helpers
const METER_TYPE_LABELS = {
  1: 'AC Energy',
  2: 'DC Energy',
  3: 'AC & DC Energy',
};

export const getMeterTypeName = (type) =>
  METER_TYPE_LABELS[Number(type)] ?? 'Unknown';

const DEFAULT_CHART_SOURCE = {
  1: 'AC',
  2: 'DC',
  3: 'AC',
};

export const getDefaultChartSource = (meterType) =>
  DEFAULT_CHART_SOURCE[Number(meterType)] ?? 'AC';

// File helpers
export function generateFileName(prefix = 'UI') {
  const now = new Date();
  const pad = (n) => String(n).padStart(2, '0');
  return `${prefix}_${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}.csv`;
}


// Mapping helpers
const toDisplayIso = (dateStr) => {
  if (!dateStr) return { display: '', iso: '' };
  const dt = new Date(dateStr);
  return {
    display: dt.toLocaleDateString('en-GB'),
    iso: dt.toISOString(),
  };
};

export function mapMetersToRows(apiRows) {
  return (apiRows ?? []).map((r) => ({
    meterNumber: r.MeterNumber,
    fromDate: toDisplayIso(r.FromDate),
    toDate: toDisplayIso(r.ToDate),
    unit: r.Unit,
    evn: r.EVN,
    meterType: r.MeterType,
    faulty: r.Faulty,
  }));
}


// Filters helpers
export function toggleFilterAndSync(type, value, prevFilters, searchParams, setSearchParams) {
  const selected = prevFilters[type] || [];
  const updated = selected.includes(value)
    ? selected.filter((o) => o !== value)
    : [...selected, value];

  if (type === 'unit') {
    const params = new URLSearchParams(searchParams);
    if (updated.length) params.set('unit', updated.join(','));
    else params.delete('unit');
    setSearchParams(params.toString());
  }
  return { ...prevFilters, [type]: updated };
}

export function clearFilterAndSync(type, prevFilters, searchParams, setSearchParams) {
  if (type === 'unit') {
    const params = new URLSearchParams(searchParams);
    params.delete('unit');
    setSearchParams(params.toString());
  }
  return { ...prevFilters, [type]: [] };
}


// Table/Grid helpers
export const coerceFaulty = (v) => v === true || v === 1 || v === '1';

export const getByPath = (obj, path) =>
  String(path)
    .split('.')
    .reduce((acc, key) => (acc == null ? undefined : acc[key]), obj);

export const sortRows = (rows, field, dir = 'asc') => {
  if (!field) return rows;
  const mult = dir === 'asc' ? 1 : -1;
  const out = [...rows];

  out.sort((a, b) => {
    if (field === '__faulty') {
      const av = coerceFaulty(a.faulty ?? a.Faulty ?? a.IsFaulty) ? 1 : 0;
      const bv = coerceFaulty(b.faulty ?? b.Faulty ?? b.IsFaulty) ? 1 : 0;
      return (av - bv) * mult;
    }
    const av = getByPath(a, field);
    const bv = getByPath(b, field);
    const as = av == null ? '' : String(av);
    const bs = bv == null ? '' : String(bv);
    return as.localeCompare(bs) * mult;
  });

  return out;
};


// String helpers
export function formatName(name) {
  if (!name) return null;
  const trimmed = String(name).trim();
  if (trimmed.includes(',')) {
    const [last, first] = trimmed.split(',').map((s) => s.trim());
    if (first && last) return `${first} ${last}`;
  }
  return trimmed;
}

export function formatToDDMMYYYY(dateStr) {
  const date = new Date(dateStr);
  if (isNaN(date)) return '';
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}
